import { get, snakeCase, toUpper } from 'lodash';
import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';

// The status the table shows for a declaration: for CDS it is the real CDS status once there is one,
// otherwise the declaration's own status. Undefined when the declaration has no status yet.
export const getDeclarationDisplayStatus = (declaration: Declaration): DeclarationStatuses | undefined => {
    if (!declaration.status) return undefined;

    const cdsRealStatus = get(declaration, 'cdsDeclaration.cdsDeclarationStatusMapping.cdsDescription');
    if (declaration.cdsDeclaration && cdsRealStatus) {
        return toUpper(snakeCase(cdsRealStatus)) as DeclarationStatuses;
    }

    return declaration.status;
};
